import React from 'react';
import { FadeIn } from './FadeIn';
import { MessageSquare, FileSignature, Wrench, Truck } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    icon: MessageSquare,
    title: t('proc.1.title'),
    description: t('proc.1.desc')
  }, {
    icon: FileSignature,
    title: t('proc.2.title'),
    description: t('proc.2.desc')
  }, {
    icon: Wrench,
    title: t('proc.3.title'),
    description: t('proc.3.desc')
  }, {
    icon: Truck,
    title: t('proc.4.title'),
    description: t('proc.4.desc')
  }];
  return <section className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-220">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <FadeIn data-id="element-222">
          <div className="text-center mb-16" data-id="element-223">
            <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-6" data-id="element-224">
              {t('proc.title')}
            </h2>
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-225">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-steel/20 z-0" data-id="element-226"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <FadeIn key={index} delay={0.1 * (index + 1)} className="relative z-10" data-id="element-227">
                <div className="flex flex-col items-center text-center" data-id="element-228">
                  <div className="w-24 h-24 rounded-full bg-white border-4 border-steel flex items-center justify-center mb-6 shadow-lg" data-id="element-229">
                    <Icon className="w-10 h-10 text-steel" data-id="element-230" />
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-231">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-232">
                    {step.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}